import { type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

interface GreenLiquidGlassButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  loading?: boolean;
  fullWidth?: boolean;
}

export function GreenLiquidGlassButton({
  children,
  loading = false,
  fullWidth = true,
  className,
  disabled,
  type = 'button',
  ...props
}: GreenLiquidGlassButtonProps) {
  return (
    <button
      {...props}
      type={type}
      disabled={disabled || loading}
      className={cn(
        'green-liquid-glass-button',
        'h-[66px] rounded-[26px] px-6 py-0',
        'text-[18px] font-semibold text-[#0f674f]',
        'transition-[transform,box-shadow,background,opacity] duration-200 ease-out',
        'active:scale-[0.985]',
        'disabled:pointer-events-none disabled:opacity-50',
        fullWidth && 'w-full',
        className,
      )}
    >
      {loading ? '...' : children}
    </button>
  );
}
